PJQ.views.schedule.ScheduleDashboard = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Schedule-Dashboard'),
        activeView: PJQ.constants.schedule.views.TASK_LIST,
        initTaskId: null,
        isShowCriticalPath: false,
        isAdmin: true
    },
    events: {
        'click .btn-notification-history': 'viewNotificationHistory',
        'click .btn-view-timeline': 'activateTimeline',
        'click .btn-view-task-list': 'activateTaskList',
        'click .btn-view-calendar': 'activateCalendar',
        'click .btn-export-schedule': 'exportSchedule',
        'click .btn-export-view': 'exportView',
        'click .btn-export-gantt': 'exportGantt',
        'click .btn-export-calendar': 'exportCalendar',
        'click .btn-share-schedule': 'shareSchedule',
        'click .btn-order-gantt': 'orderGantt',
        'click .btn-add-task': 'addTaskClicked',
        'click .btn-add-milestone': 'addMilestoneClicked',
        'click .btn-save-as-template': 'saveAsTemplate',
        'click .btn-import-template': 'importTemplate',
        'click .btn-upload-template': 'uploadTemplate',
        'click .btn-schedule-settings': 'editSettings',
        'change .cb-show-critical-path': 'showCriticalPath',
        'click .btn-view-requested-changes': 'viewRequestedChanges',
        'click .btn-zoom-in': 'zoomInGantt',
        'click .btn-zoom-out': 'zoomOutGantt',
        'click .btn-view-master': 'viewMasterSchedule',
        'click .btn-delete-look-ahead': 'deleteLookAhead',
    },
    beforeFirstRender: async function () {
        this.options.canViewLookAheads = false;
        this.options.canManageLookAheads = false;
        this.options.preferences = PJQ.app.session.project ? PJQ.app.session.project.preferences : PJQ.app.session.preferences;
        this.lookAheads = null;

        if(this.model != null){
            this.schedule = this.model;
        }

        if (this.options.project != null) {
            this.options.isAdmin = this.options.project.hasPermission('schedule.isAdmin');
            this.options.canViewLookAheads = this.options.project.hasPermission('schedule.canViewLookAheads');
            this.options.canManageLookAheads = this.options.project.hasPermission('schedule.canManageLookAheads');

            this.settings = await this.options.project.fetchScheduleSettings();
            this.model = this.schedule = await this.options.project.fetchSchedule();

            if (this.options.canViewLookAheads) {
                this.lookAheads = await this.options.project.fetchScheduleLookAheads();
            }
        } else {
            this.options.isAdmin = this.model.get('templateId') > 0 && PJQ.app.session.hasPermission('schedule.isAdmin');
            this.settings = await PJQ.app.session.fetchScheduleSettings();
        }
        this.options.activeView = this.settings.get('defaultView');

        if (this.options.initLookAheadId > 0) {
            if(this.options.shareKey != null) {
                let initLookAhead = new PJQ.models.schedule.LookAhead({
                    id: this.options.initLookAheadId
                });
                if (initLookAhead != null) {
                    this.options.lookAhead = initLookAhead;
                    await this.options.lookAhead.fetch();
                }
                this.options.initLookAheadId = null;
            }
            else if(this.lookAheads != null){
                let initLookAhead = this.lookAheads.get(this.options.initLookAheadId);
                if (initLookAhead != null) {
                    this.options.lookAhead = initLookAhead;
                    await this.options.lookAhead.fetch();
                }
                this.options.initLookAheadId = null;
            }
        }

        this.render();
    },
    beforeRender: function () {
        if (this.options.lookAhead) {
            this.model = this.options.lookAhead;
        } else {
            this.model = this.schedule;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            settings: this.settings,
            project: this.options.project,
            isShowCriticalPath: this.options.isShowCriticalPath,
            activeView: this.options.activeView,
            statuses: this.model ? this.model.statuses : new PJQ.collections.schedule.TaskStatuses(),
            isAdmin: this.options.isAdmin,
            lookAhead: this.options.lookAhead,
            canViewLookAheads: this.options.canViewLookAheads,
            canManageLookAheads: this.options.canManageLookAheads,
            preferences: this.options.preferences
        };
    },
    afterRender: function () {
        this.chart = null;

        if (this.model != null && this.model.isFetched) {
            this.$activeView = this.$('.schedule-dashboard-view');
            switch (this.options.activeView) {
                case PJQ.constants.schedule.views.TASK_LIST:
                    this.renderTaskList();
                    break;
                case PJQ.constants.schedule.views.TIMELINE:
                    this.renderTimeline();
                    break;
                case PJQ.constants.schedule.views.CALENDAR:
                default:
                    this.renderCalendar();
                    break;
            }

            if (this.options.initTaskId > 0) {
                let initTask = this.model.tasks.get(this.options.initTaskId);
                if (initTask != null) {
                    this.editTask(initTask);
                }
                this.options.initTaskId = null;
            }
            this.renderPendingCount();

            if (this.options.canViewLookAheads && this.model.get('projectId') > 0) {
                let lookAheadChoices = [{
                    id: -1,
                    name: "<i class='fal fa-plus mr-1'></i>New Look-Ahead"
                }];
                _.each(this.lookAheads.models, (lookAhead) => {
                    lookAheadChoices.push({
                        id: lookAhead.id,
                        name: '<strong>' + lookAhead.getDisplayName() + '</strong> | ' + (lookAhead.get('duration') / 7) + ' weeks',
                        subtext: 'Actual: ' + lookAhead.getDisplayName(true)
                    });
                })

                this.lookAheadPicker = new PJQ.inputs.Selectpicker({
                    el: this.$('.select-look-ahead'),
                    isIntChoices: true,
                    isMultiple: false,
                    isBlockSubtext: true,
                    defaultValue: this.options.lookAhead ? this.options.lookAhead.id : 0,
                    choices: [
                        {
                            name: "",
                            choices: [{
                                id: 0,
                                name: "Master Schedule"
                            }]
                        },
                        {
                            name: "Look-Aheads",
                            choices: lookAheadChoices
                        }
                    ],
                    onChange: (value) => {
                        if (value === -1) {
                            this.lookAheadPicker.setValue(this.options.lookAhead ? this.options.lookAhead.id : 0);
                            this.newLookAhead();
                        } else {
                            this.options.lookAhead = value > 0 ? this.lookAheads.get(value) : null;
                        }

                        if (this.options.lookAhead != null) {
                            this.options.lookAhead.fetch({
                                success: () => {
                                    this.render();
                                }
                            })
                        } else {
                            this.render();
                        }

                        let route = 'projects/' + this.model.get('projectId').toString() + '/schedule';
                        if (this.options.lookAhead != null) {
                            route += '/lookaheads/' + this.options.lookAhead.id.toString();
                        }
                        PJQ.app.router.navigate(route, {
                            trigger: false,
                            replace: true
                        });
                    }
                });
            }
        }
    },
    newLookAhead: function () {
        new PJQ.views.schedule.NewLookAheadModal({
            projectId: this.options.project.id,
            schedule: this.schedule,
            lookAheads: this.lookAheads,
            onSave: _.bind(function (lookAhead) {
                this.lookAheads.add(lookAhead);
                this.options.lookAhead = lookAhead;
                lookAhead.isFetched = true;
                this.render();
            }, this)
        });
    },
    deleteLookAhead: function () {
        if (this.options.lookAhead == null) {
            return;
        }

        new PJQ.views.modals.YesNo({
            header: "Delete Schedule Look-Ahead?",
            body: "Are you sure you want to delete this look-ahead? This action cannot be undone.",
            onYes: () => {
                this.options.lookAhead.destroy({
                    success: () => {
                        this.lookAheads.remove(this.options.lookAhead);
                        this.options.lookAhead = null;
                        this.render();

                        PJQ.notifications.notify.successNotify({
                            message: 'Look-Ahead deleted successfully'
                        });
                    }
                });
            }
        });
    },
    viewMasterSchedule: function () {
        this.options.lookAhead = null;
        this.render();
    },
    viewNotificationHistory: async function () {
        if (this.options.project == null) {
            return;
        }

        let notifications = await this.options.project.fetchScheduleNotifications(null, true);
        new PJQ.views.notifications.NotificationHistory({
            context: "Project Schedule",
            collection: notifications,
            extraColumns: [
                {
                    "index": 1,
                    "data": "",
                    "title": "Task",
                    // "width": "20%",
                    "render": function (data, type, row) {
                        return row.get('taskName') ?? "";
                    }
                }
            ]
        });
    },
    shareSchedule: function () {
        let sharingModal = new PJQ.views.sharing.SharingModal({
            subject: 'A project schedule has been shared with you',
            project: this.options.project,
            onSave: _.bind(function (data) {
                this.model.share(data, _.bind(function (share) {
                    PJQ.notifications.notify.successNotify({
                        message: 'Schedule share email sent'
                    });
                }, this));
            }, this)
        });
        this.model.share(null, function (share) {
            let callback = _.bind(sharingModal.urlChanged, sharingModal);
            callback(share.get('url'));
        });
    },
    setActiveView: function (newActiveView) {
        if (newActiveView != null) {
            this.options.activeView = newActiveView;
            this.render();
        }
    },
    activateCalendar: function () {
        this.setActiveView(PJQ.constants.schedule.views.CALENDAR);
    },
    renderCalendar: function ($overrideEl, afterChartInit = null) {
        new PJQ.views.calendars.FullCalendar({
            el: _.size($overrideEl) > 0 ? $overrideEl : this.$activeView,
            collection: this.model.tasks.getCalendarTasks(),
            schedule: this.model,
            project: this.options.project,
            onTaskEdit: _.bind(function (task) {
                this.editTask(task);
            }, this),
            canDelete: this.options.isAdmin,
            onTaskDelete: _.bind(function (task) {
                this.deleteTaskClicked(task);
            }, this)
        });
        if (typeof afterChartInit === 'function') {
            afterChartInit();
        }
    },
    activateTimeline: function () {
        this.setActiveView(PJQ.constants.schedule.views.TIMELINE);
    },
    renderTimeline: function (opts = null) {
        if (opts == null) {
            opts = {};
        }

        let hasOverride = _.size(opts.$overrideEl) > 0,
            $chart;
        if (hasOverride) {
            $chart = opts.$overrideEl;
        } else {
            if (this.chart != null) {
                this.chart.refreshTasks(this.model.tasks.getGanttTasks(), opts.contextTask);
                return;
            }

            $chart = this.$activeView;
        }
        let sortColumnCookie = PJQ.constants.cookies.SCHEDULE_GANTT_SORT_COLUMN,
            sortDirectionCookie = PJQ.constants.cookies.SCHEDULE_GANTT_SORT_DIRECTION,
            prefs = PJQ.app.session.project != null ? PJQ.app.session.project.preferences : PJQ.app.session.preferences,
            enableColumnSorting = prefs.hasPref(PJQ.constants.preferenceTypes.ENABLE_GANTT_COLUMN_SORTING),
            ch = new PJQ.views.charts.dhtmlxGantt({
                el: $chart,
                shareKey: this.options.shareKey,
                schedule: this.model,
                settings: this.settings,
                canEdit: this.options.isAdmin,
                enableSorting: enableColumnSorting,
                sortField: !enableColumnSorting ? null : PJQ.helpers.cookieHelpers.getCookie(sortColumnCookie),
                sortAsc: !enableColumnSorting ? null : PJQ.helpers.cookieHelpers.getCookie(sortDirectionCookie) === 'asc',
                isShowCriticalPath: this.options.isShowCriticalPath,
                onSort: function (sort) {
                    PJQ.helpers.cookieHelpers.setCookie(sortColumnCookie, sort.field);
                    PJQ.helpers.cookieHelpers.setCookie(sortDirectionCookie, sort.asc ? 'asc' : 'desc');
                },
                onAddSubTask: (parent) => {
                    let fnAdd = () => {
                        let newTask = new PJQ.models.schedule.Task({
                            projectId: this.model ? this.model.get('projectId') : null,
                            templateId: this.model ? this.model.get('templateId') : null,
                            lookAheadId: this.model ? this.model.get('lookAheadId') : null,
                            status: this.model.statuses.getDefault(),
                            summaryTaskId: parent.get('taskId'),
                            start: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            finish: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                                if (parent) {
                                    return model.get('summaryTaskId') === parent.get('taskId')
                                } else {
                                    return model.get('summaryTaskId') == null;
                                }
                            }, this)) + 1
                        });
                        newTask.save(null, {
                            success: _.bind(function () {
                                this.model.tasks.add(newTask);
                                this.chart.refreshTasks();
                                this.chart.startInlineEdit(newTask.id);
                            }, this)
                        });
                    }
                    if (!parent.get('isSummaryTask')) {
                        new PJQ.views.modals.YesNo({
                            header: "Convert to Summary Task?",
                            body: "Creating a sub-task will convert this task to a summary task. Are you sure you want to proceed?",
                            onYes: _.bind(function () {
                                parent.set('isSummaryTask', true);
                                fnAdd();
                            }, this)
                        });
                    } else {
                        fnAdd();
                    }
                },
                onTaskAdd: _.bind(function (task, callback) {
                    let parent = task.parent ? this.model.tasks.get(task.parent) : null,
                        newTask = new PJQ.models.schedule.Task({
                            projectId: this.model ? this.model.get('projectId') : null,
                            templateId: this.model ? this.model.get('templateId') : null,
                            status: this.model.statuses.getDefault(),
                            summaryTaskId: parent && parent.get('isSummaryTask') ? parent.get('taskId') : null,
                            parentTaskId: null,
                            start: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            finish: parent && parent.get('isSummaryTask') ? parent.get('start') : null,
                            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                                if (parent) {
                                    return model.get('summaryTaskId') === parent.get('taskId')
                                } else {
                                    return model.get('summaryTaskId') == null;
                                }
                            }, this)) + 1
                        });
                    newTask.save(null, {
                        success: _.bind(function () {
                            this.model.tasks.add(newTask);
                            this.chart.refreshTasks();
                            if (typeof callback === 'function') {
                                callback(newTask);
                            }
                        }, this)
                    });
                }, this),
                onTaskEdit: _.bind(function (task) {
                    this.editTask(task);
                }, this),
                onTaskDelete: _.bind(function (task) {
                    if (task) {
                        this.deleteTaskClicked(task, false);
                    }
                }, this),
                onTaskMoved: _.bind(function (taskModel, task, editedValue, isTrueDate = false) {
                    // The gantt considers the end_date to be the day after the last working day, e.g., Start Date is August 08, 2022, and the duration is 2 days,
                    // the Gantt considers the end_date as August 10, 2022, whereas our API considers it to be August 09, 2022. So we subtract a day from the end_date
                    let endDate = new Date(task.end_date - 1);
                    endDate.setHours(0, 0, 0, 0);
                    if (task.type === 'milestone' || isTrueDate) {
                        endDate = new Date(task.end_date);
                    }
                    if (task.unscheduled) {
                        // if the task in unscheduled, we need to handle it in different ways
                        if (editedValue === 'text') {
                            taskModel.set({
                                name: task.text,
                                start: null,
                                finish: null,
                                duration: task.duration,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        } else if (editedValue === 'start_date') {
                            taskModel.set({
                                name: task.text,
                                start: task.start_date,
                                finish: task.start_date,
                                duration: 1,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        } else if (editedValue === 'end_date') {
                            taskModel.set({
                                name: task.text,
                                start: task.end_date,
                                finish: task.end_date,
                                duration: 1,
                                percentComplete: Math.round(task.progress * 100)
                            });
                        }
                    } else {
                        taskModel.set({
                            name: task.text,
                            start: task.start_date,
                            finish: endDate,
                            duration: PJQ.helpers.dateHelpers.getDateDaysDiff(endDate, task.start_date, !taskModel.get('weekendWork'), true),
                            percentComplete: Math.round(task.progress * 100)
                        });
                    }
                    this.updateTaskTime(taskModel, taskModel.get('name'), taskModel.get('start'), taskModel.get('finish'), taskModel.get('duration'), taskModel.get('percentComplete'));
                }, this),
                onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                    if (isNewTask) {
                        this.model.tasks.add(task);
                    }
                    if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                        this.updateSummaryTask(task, summaryTaskId);
                    }
                }, this),
                onTaskUpdated: _.bind(function (taskModel, task) {
                    let endDate = new Date(task.end_date);
                    endDate.setHours(0, 0, 0, 0);
                    if (task.type === 'milestone') {
                        endDate = new Date(task.end_date);
                    }
                    taskModel.set({
                        name: task.text,
                        start: task.start_date,
                        finish: endDate,
                        duration: task.duration,
                        percentComplete: Math.round(task.progress * 100)
                    });
                    this.updateTaskTime(taskModel, taskModel.get('name'), taskModel.get('start'), taskModel.get('finish'), taskModel.get('duration'), taskModel.get('percentComplete'));
                }, this),
                onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                    if (isNewTask) {
                        this.model.tasks.add(task);
                    }
                    if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                        this.updateSummaryTask(task, summaryTaskId);
                    }
                }, this),
                onDependencyAdd: _.bind(function (task, dependencyInfo) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'schedule'
                            },
                            {
                                endpoint: 'tasks',
                                value: task.get('taskId')
                            },
                            {
                                endpoint: 'dependencies'
                            }
                        ]),
                        data: {
                            taskId: task.get('taskId'),
                            dependTaskId: parseInt(dependencyInfo.source),
                            offset: dependencyInfo.lag,
                            type: PJQ.constants.schedule.linkTypes[parseInt(dependencyInfo.type)]
                        }
                    }).post().done(_.bind(function (data) {
                        _.each(data.changes, function (task) {
                            let colTask = this.model.tasks.get(task.taskId);
                            task.start = PJQ.helpers.dateHelpers.parseDateString(task.start, false);
                            task.finish = PJQ.helpers.dateHelpers.parseDateString(task.finish, false);
                            colTask.set({
                                start: task.start,
                                finish: task.finish
                            });
                            this.chart.updateTask(colTask);
                        }, this);

                        let task = this.model.tasks.get(data.dependency.taskId);

                        // Fetch the task to get the dependencyId
                        task.fetch({
                            success: _.bind(function (task) {
                                let dependency = _.max(task.dependencies.models, function (dependency) {
                                    return dependency.get('dependencyId');
                                }, this);
                                this.model.dependencies.add(dependency);
                                this.chart.refreshTasks();
                            }, this)
                        })
                    }, this));
                }, this),
                onDependencyDelete: _.bind(function (task, dependencyInfo) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'schedule'
                            },
                            {
                                endpoint: 'tasks',
                                value: task.get('taskId')
                            },
                            {
                                endpoint: 'dependencies',
                                value: dependencyInfo.id
                            }
                        ])
                    }).delete().done(_.bind(function (data) {
                        this.model.dependencies.remove(dependencyInfo.id);
                        task.dependencies.remove(dependencyInfo.id);
                    }, this));
                }, this)
            });

        if (!hasOverride) {
            this.chart = ch;
        }
    },
    zoomInGantt: function () {
        this.chart.zoomIn();
        let zoomLevel = this.chart.getZoom();
        this.$('.btn-zoom-in').attr('disabled', (zoomLevel === 0));
        this.$('.btn-zoom-out').attr('disabled', (zoomLevel === 4));
    },
    zoomOutGantt: function () {
        this.chart.zoomOut();
        let zoomLevel = this.chart.getZoom();
        this.$('.btn-zoom-in').attr('disabled', (zoomLevel === 0));
        this.$('.btn-zoom-out').attr('disabled', (zoomLevel === 4));
    },
    showCriticalPath: function () {
        this.options.isShowCriticalPath = !this.options.isShowCriticalPath;
        this.chart.toggleCriticalPath(this.options.isShowCriticalPath);
    },
    activateTaskList: function () {
        this.setActiveView(PJQ.constants.schedule.views.TASK_LIST);
    },
    renderTaskList: function () {
        this.addLoader();
        this.taskList = new PJQ.views.schedule.TaskList({
            el: this.$activeView,
            project: this.options.project,
            schedule: this.model,
            model: this.model,
            isAdmin: this.options.isAdmin,
            onTaskEdit: _.bind(function (task) {
                this.editTask(task);
            }, this),
            onTaskDelete: _.bind(function (task) {
                this.deleteTaskClicked(task);
            }, this),
            onTaskUpdateSummary: _.bind(function (task, summaryTaskId = null, isNewTask = false) {
                if (isNewTask) {
                    this.model.tasks.add(task);
                }
                if (parseInt(summaryTaskId) !== parseInt(task.get('summaryTaskId'))) {
                    this.updateSummaryTask(task, summaryTaskId);
                }
            }, this),
            afterTableRendered: _.bind(function () {
                this.removeLoader();
            }, this)
        });
    },
    updateTaskTime: function (task, name, start, finish, duration, percentComplete) {
        this.addLoader();
        if (task.model) {
            task.model.set({
                name: name,
                duration: duration,
                percentComplete: percentComplete
            });
        }

        let fnSave = () => {
            new PJQ.ajax.Request({
                data: {
                    name: name,
                    start: start,
                    finish: finish,
                    duration: duration,
                    percentComplete: percentComplete
                },
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'schedule'
                    },
                    {
                        endpoint: 'tasks',
                        value: task.model ? task.model.get('taskId') : task.get('taskId')
                    }
                ])
            }).patch().done(_.bind(function (res) {
                this.removeLoader();
                let updatedTask = task.model ? task.model : task;
                if (_.size(res.changes) > 0) {
                    _.each(res.changes, function (change) {
                        let changedTask = this.model.tasks.get(change.taskId);
                        if (changedTask != null) {
                            changedTask.set({
                                start: PJQ.helpers.dateHelpers.parseDateString(change.start, false),
                                finish: PJQ.helpers.dateHelpers.parseDateString(change.finish, false)
                            });

                            if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                                PJQ.app.session.project.trigger('scheduleTaskChanged', changedTask, false);
                            }

                            if (this.chart && typeof this.chart.updateTask === 'function') {
                                this.chart.updateTask(changedTask);
                            }
                        }
                    }, this);
                }
                if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE) {
                    this.chart.updateTask(task);
                }
            }, this));
        };
        if ((task.model ? task.model : task).get('projectId') > 0 && this.settings.get('notificationsEnabled') && this.settings.get('dateChangeNotificationsMode') === 1) {
            let changedTasks = (task.model ? task.model : task).determineChangedTasks();
            new PJQ.views.schedule.TaskChangeNotifications({
                changedTasks: changedTasks,
                onSave: _.bind(function (res) {
                    fnSave(res.noNotify);
                }, this)
            });
        } else {
            fnSave();
        }
    },
    addLoader: function () {
        this.loader = new PJQ.Loader(this.$('.schedule-dashboard-view'));
    },
    removeLoader: function () {
        this.loader.remove();
    },
    editTask: function (task) {
        let taskModel = task,
            isNew = task.id == null;
        if (this.chart && task == null) {
            taskModel = _.find(this.chart.collection.models, function (model) {
                return model.get('id') === task.get('taskId');
            })
        }
        let fnModal = _.bind(function () {
            new PJQ.views.schedule.EditTaskModal({
                project: this.options.project,
                isSummaryTask: task.get('isSummaryTask'),
                schedule: this.model,
                model: task,
                onSave: _.bind(function () {
                    // Need to fetch the task to get any new dependencies ids, otherwise you cannot delete the dependency if you edit it again without refreshing.
                    task.fetch({
                        success: _.bind(function (taskModel) {
                            _.each(this.model.dependencies.models, function (dep) {
                                if (dep && dep.id < 0) {
                                    this.model.dependencies.remove(dep);
                                }
                                let updatedDep = taskModel.dependencies.get(dep.id);
                                if (updatedDep != null) {
                                    dep.set('offset', updatedDep.get('offset'));
                                    dep.set('type', updatedDep.get('type'));
                                }
                            }, this)
                            this.model.dependencies.add(taskModel.dependencies.models);

                            if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE) {
                                if (_.size(this.model.tasks.models) === 1) {
                                    this.render()
                                } else {
                                    this.renderTimeline();
                                }
                            } else if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                                if (_.size(this.model.tasks.models) === 1) {
                                    this.render()
                                } else {
                                    PJQ.app.session.project.trigger('scheduleTaskChanged', taskModel, isNew);
                                }
                            } else {
                                this.render();
                            }
                        }, this)
                    })
                }, this),
                onClose: _.bind(function () {
                    if (task.isNew()) {
                        this.model.tasks.remove(task);
                        if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE && _.size(this.model.tasks) > 0) {
                            this.renderTimeline();
                        } else {
                            this.render();
                        }
                    } else {
                        this.renderPendingCount();
                    }
                }, this),
                onDelete: _.bind(function () {
                    this.deleteTask(task);
                }, this)
            });
        }, this);
        if (!task.isNew()) {
            task.fetch({
                success: _.bind(function () {
                    fnModal();
                }, this)
            })
        } else {
            fnModal();
        }
    },
    deleteTaskClicked: function (task, showConfirmation = true) {
        let summaryTask = _.find(this.model.tasks.models, function (model) {
                return model.get('taskId') === task.get('summaryTaskId')
            }, this),
            isLastRemainingTask = false;
        if (summaryTask != null) {
            isLastRemainingTask = true;
            _.each(this.model.tasks.models, function (model) {
                if (model.get('summaryTaskId') === summaryTask.get('taskId') && model.get('taskId') !== task.get('taskId')) {
                    isLastRemainingTask = false;
                }
            }, this)
        }
        if (isLastRemainingTask && showConfirmation) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "This is the last remaining task in the summary task \"" + summaryTask.get('name') + "\". Deleting this task will also delete the summary task. Are you sure you want to delete this task?",
                onDelete: _.bind(function () {
                    this.deleteTask(task, summaryTask);
                }, this)
            });
        } else if (showConfirmation) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this task?",
                onDelete: _.bind(function () {
                    this.deleteTask(task);
                }, this)
            });
        } else {
            this.deleteTask(task);
        }
    },
    deleteTask: function (originalTask, summary) {
        let nestedTasks = [originalTask],
            deletedDependencies = [],
            getNestedTasks = _.bind(function (task) {
                // First get the nested tasks for the passed through task
                let taskNestedTasks = _.filter(this.model.tasks.models, function (model) {
                    return model.get('parentTaskId') === task.get('taskId') || model.get('summaryTaskId') === task.get('taskId')
                }, this);
                // Concat this tasks nested tasks with the existing nested tasks array
                nestedTasks = nestedTasks.concat(taskNestedTasks);
                //Check if any of the child tasks have children
                _.each(taskNestedTasks, function (nestedTask) {
                    let hasChild = _.find(this.model.tasks.models, function (model) {
                        return model.get('summaryTaskId') === nestedTask.get('taskId') || model.get('parentTaskId') === nestedTask.get('taskId');
                    }, this)
                    // if a child task exists, then run the function again to get those child tasks
                    if (hasChild) {
                        getNestedTasks(nestedTask);
                    }
                }, this);
            }, this);
        // Get the nested tasks that need to be deleted from the original task
        getNestedTasks(originalTask);
        // Find the dependencies that include any of the tasks that will be deleted
        _.each(this.model.dependencies.models, function (dependency) {
            let deletedTask = _.find(nestedTasks, function (task) {
                return task.get('taskId') === dependency.get('taskId') || task.get('taskId') === dependency.get('dependTaskId');
            })
            if (deletedTask) {
                deletedDependencies.push(dependency);
            }
        }, this);
        this.model.tasks.remove(nestedTasks);
        this.model.dependencies.remove(deletedDependencies);
        if (summary) {
            this.model.tasks.remove(summary)
            summary.destroy();
        }
        originalTask.destroy();
        if (this.options.activeView === PJQ.constants.schedule.views.TIMELINE && _.size(this.model.tasks.models) > 0) {
            this.chart.refreshTasks();
        } else if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST && _.size(this.model.tasks.models) > 0) {
            PJQ.app.session.project.trigger('scheduleTaskChanged', originalTask, false, false, true);
        } else {
            this.render()
        }
    },
    updateSummaryTask: function (task, summaryTaskId = null) {
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'tasks',
                    value: task.model ? task.model.get('taskId') : task.get('taskId')
                },
                {
                    endpoint: 'summary',
                    value: summaryTaskId
                }
            ]),
            data: { cloudFlareFix: true }
        }).put().done(_.bind(function () {
            if (task.model) {
                task = task.model;
            }
            if (summaryTaskId > 0) {
                let summaryTask = this.model.tasks.get(summaryTaskId),
                    existingSummaryTask = task.get('summaryTaskId') ? this.model.tasks.get(task.get('summaryTaskId')) : null
                summaryTask.set('isSummaryTask', true);
                task.set('summaryTaskId', parseInt(summaryTaskId));
                _.each(summaryTask.dependencies.models, function (dep) {
                    let id = dep.get('dependencyId');
                    _.each(this.model.tasks.models, function (model) {
                        if (model.dependencies.get(id)) {
                            model.dependencies.remove(id)
                        }
                    }, this)
                }, this)

                let name = task.get('name'),
                    start = new Date(task.get('start')),
                    finish = new Date(task.get('finish')),
                    duration = task.get('duration'),
                    percentComplete = task.get('percentComplete');
                this.updateTaskTime(task, name, start, finish, duration, percentComplete);

                // if the summary task is being changed from an existing one, check if there are any other existing tasks on that summary task.
                // if not, it will no longer be a summary task and needs to reflect that.
                if (existingSummaryTask) {
                    let existingSummaryTaskHasChildren = _.find(this.model.tasks.models, function (task) {
                        return task.get('summaryTaskId') === existingSummaryTask.get('taskId')
                    }, this) != null;
                    if (!existingSummaryTaskHasChildren) {
                        existingSummaryTask.set({
                            isSummaryTask: false,
                        });

                        let existingSummaryName = existingSummaryTask.get('name'),
                            existingSummaryStart = new Date(existingSummaryTask.get('start')),
                            existingSummaryFinish = new Date(existingSummaryTask.get('finish')),
                            existingSummaryDuration = existingSummaryTask.get('duration'),
                            existingSummaryPercentComplete = existingSummaryTask.get('percentComplete');
                        this.updateTaskTime(existingSummaryTask, existingSummaryName, existingSummaryStart, existingSummaryFinish, existingSummaryDuration, existingSummaryPercentComplete);
                    }
                }
            } else {
                let summaryTask = _.find(this.model.tasks.models, function (model) {
                    return model.get('taskId') === task.get('summaryTaskId') && model.get('taskId') !== task.get('taskId');
                },)
                let name = summaryTask.get('name'),
                    start = new Date(summaryTask.get('start')),
                    finish = new Date(summaryTask.get('finish')),
                    duration = summaryTask.get('duration'),
                    percentComplete = summaryTask.get('percentComplete');
                this.updateTaskTime(summaryTask, name, start, finish, duration, percentComplete);
                task.set('summaryTaskId', null);

                // If the summary task the task is being removed from has no more tasks underneath it, it will no longer be a summary task.
                summaryTask.set('isSummaryTask', _.find(this.model.tasks.models, function (task) {
                    return task.get('summaryTaskId') === summaryTask.get('taskId')
                }, this) != null);
            }
            if (this.options.activeView === PJQ.constants.schedule.views.TASK_LIST) {
                PJQ.app.session.project.trigger('scheduleTaskChanged', task, false, true);
            } else {
                this.render();
            }
        }, this))
    },
    addTaskClicked: function (task) {
        let parentIsSummary = false;
        if (task && parseInt(task.parent) > 0) {
            let parent = this.model.tasks.get(task.parent);
            parentIsSummary = parent.get('isSummaryTask');
        }
        let newTask = new PJQ.models.schedule.Task({
            projectId: this.model ? this.model.get('projectId') : null,
            templateId: this.model ? this.model.get('templateId') : null,
            lookAheadId: this.options.lookAhead != null ? this.options.lookAhead.id : null,
            parentTaskId: parseInt(task.parent) > 0 && !parentIsSummary ? parseInt(task.parent) : null,
            summaryTaskId: parseInt(task.parent) > 0 && parentIsSummary ? parseInt(task.parent) : null,
            sortOrder: _.size(_.filter(this.model.tasks.models, function (model) {
                return model.get('summaryTaskId') == null;
            }, this)) + 1
        });
        this.model.tasks.add(newTask);
        this.editTask(newTask);
    },
    addMilestoneClicked: function () {
        let newTask = new PJQ.models.schedule.Task({
            name: "",
            duration: 1,
            start: null,
            finish: null,
            weekendWork: false,
            isAllDay: true,
            isMilestone: true,
            percentComplete: 0,
            notes: "",
            status: this.model.statuses.getDefault(),
            projectId: this.model ? this.model.get('projectId') : null,
            templateId: this.model ? this.model.get('templateId') : null
        });
        this.model.tasks.add(newTask);
        this.editTask(newTask);
    },
    editSettings: function () {
        new PJQ.views.schedule.SettingsModal({
            model: this.settings,
            project: this.options.project,
            onSave: _.bind(function () {
                this.setActiveView(this.settings.get('defaultView'));
                this.render();
            }, this)
        });
    },
    saveAsTemplate: function () {
        new PJQ.views.schedule.SaveAsTemplateModal({
            project: this.options.project
        });
    },
    importTemplate: function () {
        new PJQ.views.schedule.ImportTemplateModal({
            project: this.options.project,
            onImport: _.bind(function (schedule) {
                this.schedule = schedule;
                this.options.project.schedule = this.model;
                this.render();
            }, this)
        });
    },
    uploadTemplate: function () {
        new PJQ.views.schedule.UploadTemplateModal({
            project: this.options.project,
            onImport: _.bind(function () {
                this.model.fetch({
                    success: _.bind(function () {
                        this.render();
                    }, this)
                });
            }, this)
        });
    },
    exportSchedule: function () {
        let projectId = null,
            endpoint = null;
        if (this.options.project == null) {
            projectId = this.model.get('projectId');
            endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: projectId
                },
                {
                    endpoint: 'schedule',
                    value: 'export'
                }
            ], [
                {
                    parameter: 'shareKey',
                    value: this.options.shareKey
                }
            ]);
        }

        new PJQ.ajax.Request({
            endpoint: this.options.project ? this.options.project.endpoint(false) + '/schedule/export' + (this.options.lookAhead != null ? ('?lookAheadId=' + this.options.lookAhead.id) : '') : endpoint,
            data: {
                isApi2: true
            }
        }).post().done(_.bind(function (response) {
            PJQ.files.downloadFile(response.url, {
                isEndpoint: false
            });
        }, this)).fail(_.bind(function (xhr, err, result) {
        }, this));
    },
    orderGantt: function () {
        this.getGanttData(_.bind(function (data) {
            new PJQ.views.schedule.OrderGanttModal({
                reportData: {
                    data: data,
                    templateName: 'schedule-gantt',
                    fileName: this.options.project.get('projectName').replace(' ', '_') + '_Gantt'
                },
                project: this.options.project
            });
        }, this));
    },
    exportView: function () {
        switch (this.options.activeView) {
            case PJQ.constants.schedule.views.CALENDAR:
                this.exportCalendar();
                return;
            case PJQ.constants.schedule.views.TASK_LIST:
                this.exportSchedule();
                return;
            case PJQ.constants.schedule.views.TIMELINE:
                this.exportGantt();
                return;
        }
    },
    exportCalendar: function () {
        let loader = new PJQ.Loader(this.$('.btn-export'), {
                type: 'button',
                loadingText: 'Exporting'
            }),
            rect = this.$('.fc-day-grid')[0].getBoundingClientRect(),
            $report = this.$activeView.clone();
        PJQ.helpers.elementHelpers.addInvisibleElement($report);
        $report.find('.fc-day-grid-container').height('inherit');

        let params = [];
        if(!this.options.project && this.options.shareKey){
            params.push({
                parameter: 'shareKey',
                value: this.options.shareKey
            })
        }

        let endpoint = PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'schedule'
            },
            {
                endpoint: 'export',
                value: 'calendar'
            }
        ], params);

        PJQ.files.queueDownload(endpoint, {
            data: {
                    html: $report.html(),
                    height: rect.height,
                    width: rect.width,
                    project: this.options.project ? this.options.project.attributes : null,
                    logoURL: PJQ.app.session.project?.preferences.hasPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL) ? PJQ.app.session.project.preferences.getPref(PJQ.constants.preferenceTypes.EMAIL_LOGO_URL) : ''
                },
            templateName: 'schedule-calendar',
            filename: (this.options.project ? this.options.project.get('projectName').replace(' ', '_') : 'Project') + '_Calendar'
        }, function(){
            $report.remove();
            loader.remove();
        }, true);
    },
    exportGantt: function (e) {
        let loader = new PJQ.Loader(this.$('.btn-export'), {
                type: 'button',
                loadingText: 'Exporting'
            }),
            $temp = $('<div class="invisible wd-100" />'),
            target = $(e.currentTarget),
            type = target.data('export'),
            fnCallback = _.bind(function () {
                loader.remove();
            }, this);

        $('body').append($temp);
        switch (type) {
            case "png":
                this.chart.exportToPNG(fnCallback);
                break;
            case "pdf":
                this.chart.exportToPDF(fnCallback);
                break;
            case "excel":
                this.chart.exportToExcel(fnCallback);
                break;
            case "msproject":
                this.chart.exportToMSProject(fnCallback);
                break;
            case "primavera":
                this.chart.exportToPrimavera(fnCallback);
                break;
        }
    },
    viewRequestedChanges: function () {
        this.model.fetch({
            success: _.bind(function () {
                new PJQ.views.schedule.ViewRequestedChangesModal({
                    model: this.model,
                    onTaskEdit: _.bind(function (task) {
                        this.editTask(task);
                    }, this),
                    onClose: _.bind(function () {
                        this.renderPendingCount();
                    }, this),
                    onApprove: _.bind(function () {
                        this.render();
                    }, this)
                })
            }, this)
        });
    },
    renderPendingCount: function () {
        if (this.options.project != null && this.options.lookAhead == null) {
            let pendingCount = _.size(_.filter(this.model.pendingRequestedChanges.models, function (change) {
                return change.get('approvedOn') == null && change.get('rejectedOn') == null;
            }));
            let btn = '<button type="button" class="btn btn-light btn-view-requested-changes ht-40p" ' + (pendingCount === 0 ? 'disabled' : '') + ' >Change Requests<span class="badge ' + (pendingCount === 0 ? 'badge-secondary' : 'badge-danger') + ' fs-14 lh-15 ml-1 req-change-count">' + pendingCount.toString() + '</span></button>',
                $btn = this.$('.btn-view-requested-changes');
            $btn.replaceWith(btn);
        }
    }
});

PJQ.views.schedule.ViewRequestedChangesModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-View-Requested-Changes'),
        subTemplates: {
            requestedChanges: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Task-Requested-Changes')
        },
        maxWidth: 800,
        width: '90%',
        onSave: null,
        onTaskEdit: null,
        onApprove: null
    },
    events: {
        'click .btn-delete-requested-change': 'deleteRequestedChange',
        'click .btn-approve-requested-change': 'approveRequestedChangeClicked',
        'click .btn-reject-requested-change': 'rejectRequestedChange',
        'click .btn-request-task': 'viewTask',
        'click .btn-close': 'close'
    },
    renderData: function () {
        return {
            model: this.model
        };
    },
    afterRender: function () {
        this.model.pendingRequestedChanges.models = _.filter(this.model.pendingRequestedChanges.models, function (model) {
            return model.get('approvedOn') === null && model.get('rejectedOn') === null;
        });
        this.renderRequestedChanges();
    },
    renderRequestedChanges: function () {
        this.renderSubTemplate(false, this.options.subTemplates.requestedChanges, this.$('.requested-changes-outer'), {
            model: this.model,
            requestedChanges: this.model.pendingRequestedChanges,
            canEdit: true,
            isPendingList: true
        });
    },
    deleteRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid);
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Deletion",
            body: "Are you sure you want to delete this requested change?",
            onDelete: _.bind(function () {
                requestedChange.set('isDeleted', true);
                this.model.isDirty = true;
                this.renderRequestedChanges();
            }, this)
        });
    },
    approveRequestedChangeClicked: function (e) {
        ;
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid),
            newStart = new Date(requestedChange.get('newStart')),
            newFinish = new Date(requestedChange.get('newFinish')),
            task = _.find(this.model.tasks.models, function (task) {
                return task.get('taskId') === requestedChange.get('taskId');
            })
        if ((newFinish.getDay() === (0 || 6) || newStart.getDay() === (0 || 6)) && !task.get('weekendWork')) {
            new PJQ.views.modals.YesNo({
                header: 'Weekend Work',
                body: 'The new start or finish falls on the weekend. Would you like to turn weekend work on?',
                onYes: _.bind(function () {
                    task.updateWeekendWork(true)
                    this.approveRequestedChange(requestedChange);
                }, this),
                onNo: _.bind(function () {
                    this.approveRequestedChange(requestedChange);
                }, this)
            })
        } else {
            this.approveRequestedChange(requestedChange);
        }
    },
    approveRequestedChange: function (change) {
        let requestedChange = change;
        requestedChange.approve(_.bind(function (res) {
            this.model.set({
                start: new Date(res.requestedChange.newStart),
                finish: new Date(res.requestedChange.newFinish)
            });
            if (_.size(res.changes) > 0) {
                _.each(res.changes, function (change) {
                    let changedTask = this.model.tasks.get(change.taskId);
                    if (changedTask != null) {
                        changedTask.set({
                            start: PJQ.helpers.dateHelpers.parseDateString(change.start, false),
                            finish: PJQ.helpers.dateHelpers.parseDateString(change.finish, false)
                        });
                    }
                }, this);
            }
            this.renderRequestedChanges();

            if (typeof this.options.onApprove === 'function') {
                this.options.onApprove();
            }
        }, this));
    },
    rejectRequestedChange: function (e) {
        let target = $(e.currentTarget),
            cid = target.closest('.card').data('cid'),
            requestedChange = this.model.pendingRequestedChanges.get(cid);
        requestedChange.reject(_.bind(function (res) {
            this.renderRequestedChanges();
        }, this));
    },
    viewTask: function (e) {
        let target = $(e.currentTarget),
            taskId = target.data('taskId'),
            task = this.model.tasks.get(taskId);
        this.editTask(task);
    },
    editTask: function (task) {
        if (typeof this.options.onTaskEdit === 'function') {
            this.options.onTaskEdit(task);
        }
    },
    close: function () {
        if (typeof this.options.onClose === 'function') {
            this.options.onClose();
        }
    }
});

PJQ.views.schedule.OrderGanttModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.SCHEDULE, 'Modal-Order-Gantt'),
        maxWidth: 500,
        onSave: null
    },
    events: {
        'click .btn-order': 'order'
    },
    renderData: function () {
        let email = '',
            phone = '';
        if (PJQ.app.session.user != null) {
            email = PJQ.app.session.user.get('email');
            phone = PJQ.app.session.user.get('phone');
        } else if (PJQ.app.session.contact != null) {
            phone = PJQ.app.session.contact.get('phone');
        }
        return {
            email: email,
            phone: phone
        };
    },
    afterRender: function () {
        PJQ.helpers.inputHelpers.inputMaskPhone(this.$('.input-phone'));
    },
    order: function () {
        let isValid = true,
            $email = this.$('.input-email'),
            email = $email.val();
        if (!PJQ.helpers.validators.validateEmail(email).success) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError($email, false);
        } else {
            PJQ.helpers.inputHelpers.setInputError($email, true);
        }

        let $phone = this.$('.input-phone'),
            phone = PJQ.helpers.formatHelpers.numbersOnly($phone.val());
        if (_.size(phone) < 10) {
            isValid = false;
            PJQ.helpers.inputHelpers.setInputError($phone, false);

        } else {
            PJQ.helpers.inputHelpers.setInputError($phone, true);
        }

        if (!isValid) {
            return;
        }

        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: this.options.project.id
                },
                {
                    endpoint: 'schedule'
                },
                {
                    endpoint: 'ordergantt'
                }
            ], [
                {
                    parameter: 'email',
                    value: email
                },
                {
                    parameter: 'phone',
                    value: phone
                }
            ]),
            data: this.options.reportData
        }).post().done(_.bind(function () {
            PJQ.notifications.notify.successNotify({
                message: 'Print order placed successfully'
            });
            this.removeModal();
        }, this));
    }
});
